module.exports = __webpack_public_path__ + "王鹏宇-2b5a25cf.png";